if (!customElements.get('media-gallery') || !customElements.get('media-gallery-lite')) {
  (function($) {
    var $ = jQuery = $;
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.productGallery = this.querySelector(`.product-single__gallery-${this.dataset.section}`);
        this.thumbnailsWrapper = this.querySelector('.thumbnails-wrapper');
        this.productThumbnails = this.thumbnailsWrapper ? this.thumbnailsWrapper.querySelector('.product-single__thumbnails') : {};
        const productVariants = document.getElementById(`VariantSelect-${this.dataset.section}`);
        let options;
        let currentVariant;
        let mediaId = null;

        if (productVariants) {
          options = productVariants.productData ? productVariants.productData.options : null;
          currentVariant = productVariants.currentVariant;
          if (currentVariant && currentVariant.featured_media) {
            mediaId = `${this.dataset.section}-${currentVariant.featured_media.id}`;
          }
        }

        this.hasInteracted = false;
        this.initInteractionFlag();
        this.initBreakpoints();
        this.initGallerySlider();
        this.initThumbnails();
        this.setActiveMedia(mediaId, options, currentVariant);
      }

      // H-02: the thumbnail rail must not smooth-scroll at init time — Chrome
      // ends LCP tracking on the first scroll, which made PDP LCP unmeasurable.
      // Smooth scrolling is re-enabled (class + behavior) on first real input.
      initInteractionFlag() {
        const mark = () => this.markInteracted();
        ['pointerdown', 'touchstart', 'keydown', 'wheel', 'mousedown'].forEach((type) => {
          this.addEventListener(type, mark, { once: true, passive: true });
        });
      }

      markInteracted() {
        if (this.hasInteracted) return;
        this.hasInteracted = true;
        const list = this.productThumbnails;
        if (list && list.classList) list.classList.add('is-interactive');
      }

      initBreakpoints() {
        this.wideBreakpointHandler = {
          match: () => { this.bpSmall = false; },
          unmatch: () => { this.bpSmall = true; }
        };
        this.desktopBreakpointHandler = {
          match: () => { this.blockSlide3DModel = true; }
        };
        enquire.register('screen and (min-width: 1280px)', this.wideBreakpointHandler);
        enquire.register('screen and (min-width: 1001px)', this.desktopBreakpointHandler);
      }

      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          enquire.unregister('screen and (min-width: 1280px)', this.wideBreakpointHandler);
          enquire.unregister('screen and (min-width: 1001px)', this.desktopBreakpointHandler);
          window.removeEventListener('keydown', this.onGalleryKeydown);
          $(this).find('.slick-initialized').each(function () {
            $(this).slick('unslick');
          });
        });
      }

      autoFitIsSupported() {
        const { userAgent } = window.navigator;

        if (userAgent.includes('Firefox/')) {
          // const version = parseInt(userAgent.split('Firefox/')[1]);

          // if (version <= 76) {
          return false;
          // }
        }

        return true;
      }

      initGallerySlider() {
        const self = this;
        const $productGallery = $(this.productGallery);
        const galleryInitialized = $productGallery.hasClass('slick-initialized');
        const optionsGallery = {
          arrows: true,
          // H-02: never swallow a tap that lands mid-animation, and keep the
          // animation short enough that a 350ms tap cadence always lands.
          waitForAnimate: false,
          speed: 250
        };
        if(galleryInitialized) return;

        $productGallery.on('init', function(event, slick){
          if (self.blockSlide3DModel === true) {
            const is3DModelActive = $productGallery.find('.slick-current .product-media-modal__model');
            if (is3DModelActive.length) {
              slick.slickSetOption('swipe', false);
            }
          }
        });

        $productGallery.slick(optionsGallery);

        $productGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          self.setActiveThumbnail(null, nextSlide);
        });

        $productGallery.on('afterChange', function(event, slick, currentSlide){
          const activeMedia = $productGallery.find('.slick-current');
          if (activeMedia.length) {
            self.playActiveMedia(activeMedia[0]);
          }

          if (self.blockSlide3DModel === true) {
            const is3DModel = $productGallery.find('.slick-current .product-media-modal__model');

            if (is3DModel.length) {
              slick.slickSetOption('swipe', false);
            } else if (slick.slickGetOption('swipe') ===  false) {
              slick.slickSetOption('swipe', true);
            }
          }
        });

        this.onGalleryKeydown = (event) => {
          if (event.code === 'ArrowLeft') {
            $productGallery.slick('slickPrev');
          } else if (event.code === 'ArrowRight') {
            $productGallery.slick('slickNext');
          }
        };
        window.addEventListener('keydown', this.onGalleryKeydown);

        // Accessibility concerns not yet fixed in Slick Slider
        $(this)
        .find('.product-single__wrapper')
        .find('.slick-list')
        .removeAttr('aria-live');
        $(this)
        .find('.product-single__wrapper')
        .find('.slick-disabled')
        .removeAttr('aria-disabled');
      }

      initThumbnails() {
        const thumbImages = this.querySelectorAll(`.product-single__thumbnail--${this.dataset.section}`);
        if (!thumbImages.length) return;

        thumbImages.forEach((thumbImage) => {
          const self = this;

          thumbImage.addEventListener('click', function (e) {
            e.preventDefault();
            self.markInteracted();
            const mediaId = this.dataset.thumbnailId;
            self.setActiveThumbnail(mediaId);
          });
        });
      }

      setActiveThumbnail(mediaId = null, nextSlide = null) {
        let $activeThumbnail;
        let $activeThumbnailWrapper;
        let slideIndex = 0;
        const $gallery = $(this);
        const $thumbnailWrappers = $gallery.find('.product-single__thumbnails-item');
        const $thumbnailActiveWrappers = $gallery.find(
          '.product-single__thumbnails-item:not(.product-single__thumbnails--hide)'
        );
        const $slickGallery = $(this.productGallery);
        const $thumbImages = $gallery.find(`.product-single__thumbnail--${this.dataset.section}`);
      
        if (!mediaId) {
          let activeSlide = $slickGallery.slick('slickCurrentSlide');
      
          if (nextSlide != null) {
            activeSlide = nextSlide;
          }
      
          $activeThumbnail = $($thumbnailActiveWrappers[activeSlide]).find('.product-single__thumbnail');
          $activeThumbnailWrapper = $($thumbnailActiveWrappers[activeSlide]).find('.product-single__thumbnails-item');
          mediaId = $activeThumbnail.data('thumbnail-id');
        } else {
          $activeThumbnail = $thumbnailWrappers.find(
            `.product-single__thumbnail--${this.dataset.section}[data-thumbnail-id='${mediaId}']`
          );
        }
      
        $thumbImages
          .removeClass('active-thumb')
          .removeAttr('aria-current');
      
        $thumbnailWrappers.removeClass('active');
      
        $activeThumbnail.addClass('active-thumb');
        $activeThumbnail.attr('aria-current', true);
      
        $activeThumbnail.closest('.product-single__thumbnails-item').addClass('active');

        $thumbnailActiveWrappers.each(function (index, element) {
          const thumbnailId = $(element).find('.product-single__thumbnail').data('thumbnail-id');
          if (thumbnailId === mediaId) {
            slideIndex = index;
          }
        });
      
        // H-02: with waitForAnimate:false a nested slickGoTo from inside
        // beforeChange would re-enter this method forever. When we are already
        // reacting to a slide change (nextSlide != null) slick is on its way to
        // that slide, so only sync the thumbnail UI.
        if (nextSlide == null && !this._syncingSlide) {
          this._syncingSlide = true;
          try {
            $slickGallery.slick('slickGoTo', slideIndex, true);
          } finally {
            this._syncingSlide = false;
          }
        }
        this.scrollActiveThumbnailIntoView($activeThumbnail.get(0));
      }      

      scrollActiveThumbnailIntoView(thumbnail) {
        const thumbnailList = this.productThumbnails;
        const thumbnailItem = thumbnail ? thumbnail.closest('.product-single__thumbnails-item') : null;

        if (
          !thumbnailItem ||
          !thumbnailList ||
          thumbnailList.scrollWidth <= thumbnailList.clientWidth + 1
        ) return;

        window.requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const listRect = thumbnailList.getBoundingClientRect();
          const itemRect = thumbnailItem.getBoundingClientRect();
          const itemStyle = window.getComputedStyle(thumbnailItem);
          const step = itemRect.width + parseFloat(itemStyle.marginLeft || 0) + parseFloat(itemStyle.marginRight || 0);
          const farOutside = itemRect.right > listRect.right + step || itemRect.left < listRect.left - step;

          const behavior = this.hasInteracted ? 'smooth' : 'auto';

          if (farOutside) {
            if (this.hasInteracted) {
              // Move only the rail; scrollIntoView can also move the page.
              thumbnailList.scrollBy({
                left: itemRect.left - listRect.left - (thumbnailList.clientWidth - itemRect.width) / 2,
                behavior: 'smooth'
              });
            } else {
              thumbnailList.scrollLeft = thumbnailItem.offsetLeft - (thumbnailList.clientWidth - itemRect.width) / 2;
            }
            return;
          }

          // The one-step edge nudge is a nicety: never run it at load time.
          // This is the ~4px smooth scroll that truncated LCP measurement.
          if (!this.hasInteracted) return;

          let scrollAmount = 0;
          if (itemRect.right >= listRect.right - 2) {
            scrollAmount = Math.min(step, thumbnailList.scrollWidth - thumbnailList.clientWidth - thumbnailList.scrollLeft);
          } else if (itemRect.left <= listRect.left + 2) {
            scrollAmount = -Math.min(step, thumbnailList.scrollLeft);
          }

          if (scrollAmount) thumbnailList.scrollBy({ left: scrollAmount, behavior: behavior });
        });
      }

      camelize(str) {
        return str.replace(/\W+(.)/g, function(match, chr) {
          return chr.toUpperCase();
        });
      }

      setActiveMedia(mediaId, productOptions, currentVariant) {
        if (!this.productGallery) return; // guard: product has no gallery markup (fixes null this.productGallery.querySelector)
        const enableAllImages = this.dataset.enableAllImages;
        const $gallery = $(this);
        const $slickGallery = $(this.productGallery);
        const $thumbnailWrappers = $gallery.find('.product-single__thumbnails-item');
        const self = this;
        let slideIndex = 0;
        let colorValue;
        let setThumbnail = false;

        if (productOptions && currentVariant) {
          const productSwatchesArray = this.dataset.productSwatches.split(',');

          productOptions.forEach((option, i) => {
            const optionName = option.toLowerCase().trim();
            const productSwatch = productSwatchesArray.find((value) => value.trim() === optionName );

            if (productSwatch) {
              colorValue = currentVariant.options[i];
            }
          });
        }

        if (colorValue && enableAllImages === "false") {
          const colorValueCamelize = this.camelize(colorValue.toLowerCase());

          $thumbnailWrappers.each((index, elem) => {
            const $wrapper = $(elem);
            const alt = $wrapper.find('img').data('alt');
            const altColor = alt.match(/\(([^)]+)\)/) ? alt.match(/\(([^)]+)\)/)[1] : '';
            const altColorCamelize = this.camelize(altColor.toLowerCase());

            while ( $thumbnailWrappers.length === 1 ) {
              $wrapper = $wrapper.parent();
            }

            if (altColor === '') {
              $wrapper.removeClass('product-single__thumbnails--hide');
              return;
            }

            if ( altColorCamelize === colorValueCamelize ) {
              $wrapper.removeClass('product-single__thumbnails--hide');
            } else {
              $wrapper.addClass('product-single__thumbnails--hide');
            }
          });

          $slickGallery.slick('slickUnfilter');
          $slickGallery.slick('slickFilter', function () {
            const altImage = $(this).attr('data-alt');
            const altImageColor = altImage.match(/\(([^)]+)\)/) ? altImage.match(/\(([^)]+)\)/)[1] : '';
            const altImageColorCamelize = self.camelize(altImageColor.toLowerCase());

            if (altImageColor === '') {
              return true;
            }

            return altImageColorCamelize === colorValueCamelize;
          });

          const $hideThumbnails = $gallery.find('.product-single__thumbnails--hide');

          if ($hideThumbnails.length === 0 && mediaId) {
            const activeMedia = this.productGallery.querySelector(`[data-media-id="${ mediaId }"]`);
            if (activeMedia) slideIndex = parseInt(activeMedia.dataset.slickIndex);
          } else if (mediaId) {
            setThumbnail = true;
            self.setActiveThumbnail(mediaId);
          }

        } else {
          $thumbnailWrappers.each(function(index, elem) {
            const $wrapper = $(elem);
            while ( $thumbnailWrappers.length === 1 ) {
              $wrapper = $wrapper.parent();
            }
            $wrapper.removeClass('product-single__thumbnails--hide');
          });

          if (mediaId) {
            const activeMedia = this.productGallery.querySelector(`[data-media-id="${ mediaId }"]`);
            if (activeMedia) slideIndex = parseInt(activeMedia.dataset.slickIndex);
          }
        }

        if (!setThumbnail) {
          $slickGallery.slick('slickGoTo', slideIndex, true);
        }

        const activeMedia = this.productGallery.querySelector(`[data-slick-index="${ $slickGallery.slick('slickCurrentSlide') }"]`);
        this.playActiveMedia(activeMedia);
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia(this);
        if (activeItem) {
          const video = activeItem.querySelector('video');

          if (video && video.getAttribute('autoplay')) {
            video.play();
          }

          const deferredMedia = activeItem.querySelector('.deferred-media:not(product-model)');
          if (deferredMedia && deferredMedia.dataset.preventAutoplay) return;
          if (deferredMedia && deferredMedia.loadContent) deferredMedia.loadContent(false);
        }
      }
    }

    customElements.define('media-gallery', MediaGallery);

    class MediaGalleryLite extends MediaGallery {
      constructor() {
        super();
      }

      initGallerySlider() {
        const self = this;
        const sectionId = this.dataset.section;
        const $productGallery = $(`.product-single__gallery-${sectionId}`);
        const $galleryNav = $(`.product-single__thumbnails-${sectionId}`);
        const optionsGallery = {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          waitForAnimate: false,
          speed: 250,
          asNavFor: `.product-single__thumbnails-${sectionId}`
        };
        const optionsNav = {
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: `.product-single__gallery-${sectionId}`,
          centerMode: true,
          centerPadding: '0px',
          focusOnSelect: true,
          vertical: true,
          arrows: true,
          waitForAnimate: false,
          speed: 250,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                vertical: false
              }
            }
          ]
        }

        $productGallery.on('init', function(event, slick){
          if (self.blockSlide3DModel === true) {
            const is3DModelActive = $productGallery.find('.slick-current .product-media-modal__model');
            if (is3DModelActive.length) {
              slick.slickSetOption('swipe', false);
            }
          }
        });

        $productGallery.slick(optionsGallery);
        $galleryNav.slick(optionsNav);

        $productGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          self.setActiveThumbnail(null, nextSlide);
        });

        $productGallery.on('afterChange', function(event, slick, currentSlide){
          const activeMedia = $productGallery.find('.slick-current');
          if (activeMedia.length) {
            self.playActiveMedia(activeMedia[0]);
          }

          if (self.blockSlide3DModel === true) {
            const is3DModel = $productGallery.find('.slick-current .product-media-modal__model');

            if (is3DModel.length) {
              slick.slickSetOption('swipe', false);
            } else if (slick.slickGetOption('swipe') ===  false) {
              slick.slickSetOption('swipe', true);
            }
          }
        });

        this.onGalleryKeydown = (event) => {
          if (event.code === 'ArrowLeft') {
            $productGallery.slick('slickPrev');
          } else if (event.code === 'ArrowRight') {
            $productGallery.slick('slickNext');
          }
        };
        window.addEventListener('keydown', this.onGalleryKeydown);

        // Accessibility concerns not yet fixed in Slick Slider
        $('.product-single__wrapper')
        .find('.slick-list')
        .removeAttr('aria-live');
        $('.product-single__wrapper')
        .find('.slick-disabled')
        .removeAttr('aria-disabled');
      }
    }

    customElements.define('media-gallery-lite', MediaGalleryLite);
  })(theme.jQuery);
}
